import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CurrentPlanTag } from '../current-plan-tag';
import { NextChargeTag } from '../next-charge-tag';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanTagsProps as Props } from './types';
import { usePlanCardContext } from '../../context';
import { MostPopularTag } from '../most-popular-tag';

export const PlanTags = memo(({ className }: Props) => {
  const { isMostPopular } = usePlanCardContext();
  return (
    <Styled.Wrapper
      className={classnames('PlanTags', className)}
      sx={SX.root}
      direction="row"
    >
      <CurrentPlanTag />
      {isMostPopular && <MostPopularTag />}
      <NextChargeTag />
    </Styled.Wrapper>
  );
});

PlanTags.displayName = 'PlanTags';
